import { call, put, select, takeLatest } from 'redux-saga/effects';

import { userApi } from '../../api';

import * as actions from './actions';
import { selectFavoritesData } from './selectors';
import { ActionUpdateFavoritesType } from './types';

function* getFavorites() {
  try {
    yield put({ type: actions.GET_FAVORITES_PENDING });

    const data = yield call(userApi.getFavorites);

    yield put({ type: actions.GET_FAVORITES_FULFILLED, payload: data });
  } catch (e) {
    yield put({ type: actions.GET_FAVORITES_REJECTED, payload: e });
  }
}

function* updateFavorites(action: ActionUpdateFavoritesType) {
  try {
    yield put({ type: actions.UPDATE_FAVORITES_PENDING });

    const favorites = yield select(selectFavoritesData);
    yield call(userApi.updateFavorites, favorites);

    yield put({ type: actions.UPDATE_FAVORITES_FULFILLED });
  } catch (e) {
    yield put({ type: actions.UPDATE_FAVORITES_REJECTED, payload: e });
  }
}

export function* watchGetFavorites() {
  yield takeLatest(actions.GET_FAVORITES, getFavorites);
}

export function* watchUpdateFavorites() {
  yield takeLatest(actions.UPDATE_FAVORITES, updateFavorites);
}
